<!-- 调拨单列表 -->
<template>
    <div id="transOrders" class="business-content-main trans-order">
        <div class="bread-nav">
            <breadcrumb :canBackHistory="false"></breadcrumb>
        </div>
        <div class="search-ctn">
            <div class="search-ctn-left">
                <el-button v-if="permission.addTrans || permissionTr.addTrans" size="small" icon="el-icon-plus" class="search-btn btn-primary" @click="gotoTransWarehouseEdit(3)">
                    {{ permission.addTrans ? permission.addTrans : permissionTr.addTrans }} (F1)
                </el-button>
                <el-button v-if="permission.addTrans_v2" size="small" icon="el-icon-plus" class="search-btn btn-primary" @click="gotoTransWarehouseEdit_v2(3)">
                    {{ permission.addTrans_v2}} (F1)
                </el-button>                
                <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" @click="showSearchDialog">查询 (F2)</el-button>
                <el-button v-if="permission.printTrans" size="small" icon="el-icon-printer" class="search-btn btn-primary" @click="print()"
                    >{{ permission.printTrans }}(F3)</el-button
                >
                <el-button v-if="permission.trans || permissionTr.trans" size="small" class="search-btn btn-primary" @click="gotoTransShelf()">
                    {{ permission.trans ? permission.trans : permissionTr.trans }} (F4)
                </el-button>
                <el-button v-if="permission.transScanOut" title="扫码出仓" size="small" class="search-btn" type="warning" @click="scanTransOut()"
                    >{{ permission.transScanOut }}(F5)</el-button
                >
                <el-button v-if="permission.transScanIn" title="扫码入仓" size="small" class="search-btn" type="warning" @click="scanTransIn()"
                    >{{ permission.transScanIn }}(F6)</el-button
                >
                <el-button v-if="permission.importCreateOrder" title="导入开单" size="small" class="search-btn btn-primary" @click="importTramsferOrder()"
                    >{{ permission.importCreateOrder }}(F7)</el-button
                >
                <el-button v-if="permission.dbHistories" title="调拨配件历史" size="small" class="search-btn btn-primary" @click="dbHistories()"
                    >{{ permission.dbHistories }}(F8)</el-button
                >
                <el-button v-if="permission.dbPlan" title="调拨计划明细" size="small" class="search-btn btn-primary" @click="dbPlan()"
                    >{{ permission.dbPlan }}(F9)</el-button
                >
            </div>
            <div class="search-ctn-right" v-if="summaryStr">
                <div class="section-summary">
                    <div>
                        <span>{{ summaryStr }}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="table-ctn">
            <el-table
                :header-cell-style="{ background: '#F2F6FC' }"
                :data="tableData"
                border=""
                style="width: 100%"
                @selection-change="handleSelectionChange"
                @cell-dblclick="handleDBClick"
                :tableCode="tableCode"
                empty-text="暂无相关库存商品信息"
                v-loading="loading"
                ref="multipleTable"
            >
                <el-table-column type="selection" width="55" fixed="left"></el-table-column>
                <template v-for="(col, index) in columnShowSets">
                    <el-table-column
                        v-bind:key="col.ColumnCode + index"
                        :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                        :label="col.ColumnName"
                        resizable
                        :sortable="col.IsSort ? 'custom' : false"
                        header-align
                        :prop="col.ColumnCode"
                        v-if="col.ColumnCode == 'TOCode'"
                        show-overflow-tooltip
                    >
                        <template slot-scope="scope">
                            <el-badge :value="'打印' + scope.row.PrintedCount + '次'" class="mark" type="danger" v-if="scope.row.PrintedCount > 0">{{ scope.row.TOCode }}</el-badge>
                            {{ scope.row.PrintedCount > 0 ? '' : scope.row.TOCode }}
                        </template>
                    </el-table-column>
                    <el-table-column
                        v-bind:key="col.ColumnCode + index"
                        :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                        :label="col.ColumnName"
                        resizable
                        :sortable="col.IsSort ? 'custom' : false"
                        header-align
                        :prop="col.ColumnCode"
                        v-else-if="col.ColumnCode == 'OutWarehouseCode'"
                        show-overflow-tooltip
                    >
                        <template slot-scope="scope">
                            {{ scope.row.OutWarehouseCode }}
                            <span v-if="scope.row.OutWarehouseType == 1" style="color: #8492a6">(前置仓)</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        v-bind:key="col.ColumnCode + index"
                        :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                        :label="col.ColumnName"
                        resizable
                        :sortable="col.IsSort ? 'custom' : false"
                        header-align
                        :prop="col.ColumnCode"
                        v-else-if="col.ColumnCode == 'IntWarehouseCode'"
                        show-overflow-tooltip
                        fixed="left"
                    >
                        <template slot-scope="scope">
                            {{ scope.row.IntWarehouseCode }}
                            <span v-if="scope.row.OutWarehouseType == 1" style="color: #8492a6">(前置仓)</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        v-bind:key="col.ColumnCode + index"
                        :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                        :label="col.ColumnName"
                        resizable
                        :sortable="col.IsSort ? 'custom' : false"
                        header-align
                        :prop="col.ColumnCode"
                        show-overflow-tooltip
                        v-else
                    >
                    </el-table-column>
                </template>
                <el-table-column fixed="right" label="操作" :isCanSet="true" :autoWidth="true">
                    <template slot-scope="scope">
                        <div class="ops-ctn">
                            <el-button
                                v-if="(permission.editTrans || permissionTr.editTrans) && scope.row.IsCanUpdate"
                                title="编辑"
                                size="mini"
                                type="text"
                                @click="gotoTransWarehouseEdit(2, scope.row)"
                                >编辑</el-button
                            >
                           <el-button
                                v-if="permission.editTrans_v2 && scope.row.IsCanUpdate"
                                title="编辑"
                                size="mini"
                                type="text"
                                @click="gotoTransWarehouseEdit_v2(2, scope.row)"
                                >{{permission.editTrans_v2}}</el-button
                            >                            
                            <el-button
                                v-if="(permission.submitTrans || permissionTr.submitTrans) && scope.row.IsCanSubmit"
                                title="提交"
                                size="mini"
                                type="text"
                                @click="submit(scope.row)"
                                >提交</el-button
                            >
                            <el-button
                                v-if="(permission.updateOrderAfterSubmit || permissionTr.updateOrderAfterSubmit) && scope.row.IsCanUpdateOrderAfterSubmit"
                                title="修改"
                                size="mini"
                                type="text"
                                @click="gotoTransWarehouseEdit(4, scope.row)"
                                >修改</el-button
                            >
                            <el-button
                                v-if="permission.updateOrderAfterSubmit_v2  && scope.row.IsCanUpdateOrderAfterSubmit"
                                title="修改"
                                size="mini"
                                type="text"
                                @click="gotoTransWarehouseEdit_v2(4, scope.row)"
                                >{{permission.updateOrderAfterSubmit_v2}}</el-button
                            >                            
                            <el-button
                                v-if="permission.transWarehouseOut && scope.row.IsCanOutWarehouse && scope.row.OutWarehouseType == 0"
                                title="出仓"
                                size="mini"
                                type="text"
                                @click="warehouseOut(scope.row.TOId)"
                                >出仓</el-button
                            >
                            <el-button
                                v-if="permission.transScanOut && scope.row.IsCanOutWarehouse && scope.row.OutWarehouseType == 0"
                                title="扫码出仓"
                                size="mini"
                                type="text"
                                @click="scanTransOut(scope.row.TOId)"
                                >{{ permission.transScanOut }}</el-button
                            >
                            <el-button
                                v-if="permission.transWarehouseIn && scope.row.IsCanInWarehouse && scope.row.InWarehouseType == 0"
                                title="入仓"
                                size="mini"
                                type="text"
                                @click="warehouseIn(scope.row.TOId)"
                                >入仓</el-button
                            >
                            <el-button
                                v-if="permission.transScanIn && scope.row.IsCanInWarehouse && scope.row.InWarehouseType == 0"
                                title="扫码入仓"
                                size="mini"
                                type="text"
                                @click="scanTransIn(scope.row.TOId)"
                                >{{ permission.transScanIn }}</el-button
                            >
                            <el-button
                                v-if="(permission.cancelTrans || permissionTr.cannelTrans) && scope.row.IsCanCancel"
                                title="撤销"
                                size="mini"
                                type="text"
                                style="color: orange"
                                @click="cancel(scope.row)"
                                >撤销</el-button
                            >
                            <el-button
                                v-if="(permission.delTrans || permissionTr.delTrans) && scope.row.IsCanDelete"
                                title="删除"
                                size="mini"
                                type="text"
                                style="color: red"
                                @click="del(scope.row)"
                                >删除</el-button
                            >
                            <el-button
                                v-if="(scope.row.StateName == '已提交' || scope.row.StateName == '已出仓'|| scope.row.StateName == '已完成') && permission.ExportDetails"
                                title="导出"
                                size="mini"
                                type="text"
                                @click="ExportDetails(scope.row)"
                                >导出</el-button
                            >
                            <el-button v-if="permission.opRecords" title="操作记录" size="mini" type="text" @click="opRecords(scope.row)">{{ permission.opRecords }}</el-button>
                            <el-button v-if="permission.tranOutLabels && scope.row.OutWarehouseType != 1 && (scope.row.StateName == '已提交' || scope.row.StateName == '已出仓'|| scope.row.StateName == '已完成')" title="查看调出标签" size="mini" style="color: orange" type="text" @click="showOutLabelDetails(scope.row)">查看调出标签</el-button>
                            <el-button v-if="permission.tranInLabels && scope.row.InWarehouseType != 1 && (scope.row.StateName == '已提交' || scope.row.StateName == '已出仓'|| scope.row.StateName == '已完成')" title="查看调入标签" size="mini" style="color: orange" type="text" @click="showInLabelDetails(scope.row)">查看调入标签</el-button>
                            <el-button v-if="permission.transBoxes && (scope.row.StateName == '已提交' || scope.row.StateName == '已出仓'|| scope.row.StateName == '已完成')" title="查看外箱条码" size="mini" style="color: orange" type="text" @click="showBoxDetails(scope.row)">外箱条码</el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pagination-ctn">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="searchData.Page"
                :page-sizes="[commonPageSize, 20, 30, 40, 50]"
                :page-size="searchData.limit"
                layout="total, sizes, prev, pager, next, jumper"
                :total="tableDataLength"
            ></el-pagination>
        </div>
        <!--   出仓     -->
        <el-dialog :close-on-click-modal="false" title="调拨单出仓" :visible.sync="outVisible" width="1000px">
            <div v-if="outVisible">
                <warehouseOut :EntpTOId="toId" @closeDialog="closeOutDialog"></warehouseOut>
            </div>
        </el-dialog>
        <!--   入仓     -->
        <el-dialog :close-on-click-modal="false" title="调拨单入仓" :visible.sync="inVisible" width="1000px">
            <div v-if="inVisible">
                <warehouseIn :EntpTOId="toId" @closeDialog="closeInDialog"></warehouseIn>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" title="调拨单打印" :visible.sync="dialogVisible" width="870px">
            <div class="dialog-content" v-if="dialogVisible">
                <printTranContent @closeDialog="closeDialog" :printIds="idList"></printTranContent>
            </div>
        </el-dialog>
        <el-dialog
            :close-on-click-modal="false"
            title="调拨单搜索"
            :visible.sync="dialogSearchVisible"
            width="400px"
            append-to-body
            v-dialog-drag
            lock-scroll
            :modal="false"
            id="search-trans-dialog"
            custom-class="search-item-dialog"
            style="margin-left: -170px"
        >
            <div class="dialog-content" v-if="dialogSearchVisible">
                <el-form ref="form" label-position="left" label-width="70px">
                    <el-form-item label="调拨单号">
                        <el-input ref="search_0" size="small" v-model.trim="searchData.OrderCode" v-filter-special-char="searchData.OrderCode" placeholder="调拨单号"></el-input>
                    </el-form-item>
                    <el-form-item label="调出仓库">
                        <el-select ref="search_1" v-model="searchData.OutWarehouseId" size="small" filterable clearable remote style="width: 100%" @visible-change="getWarehouse()">
                            <el-option v-for="optionItem in warehouseList" :label="optionItem.WarehouseName" :value="optionItem.WarehouseId" v-bind:key="optionItem.index">
                                <span style="float: left">{{ optionItem.WarehouseName }}</span>
                                <span v-if="optionItem.Type == 1" style="float: right; color: #8492a6; font-size: 13px">（前置仓）</span>
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="调入仓库">
                        <el-select ref="search_2" v-model="searchData.InWarehouseId" size="small" filterable clearable remote style="width: 100%" @visible-change="getWarehouse()">
                            <el-option v-for="optionItem in warehouseList" :label="optionItem.WarehouseName" :value="optionItem.WarehouseId" v-bind:key="optionItem.index">
                                <span style="float: left">{{ optionItem.WarehouseName }}</span>
                                <span v-if="optionItem.Type == 1" style="float: right; color: #8492a6; font-size: 13px">（前置仓）</span>
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="调拨总额">
                        <div class="flex">
                            <el-select size="small" class="search-item" style="width: 90px" v-model="searchData.Symbol" clearable placeholder="符号">
                                <el-option key=">=" label=">=" value=">="></el-option>
                                <el-option key=">" label=">" value=">"></el-option>
                                <el-option key="<=" label="<=" value="<="></el-option>
                                <el-option key="<" label="<" value="<"></el-option>
                                <el-option key="=" label="=" value="="></el-option>
                                <el-option key="!=" label="!=" value="!="></el-option>
                                <el-option key="between" label="区间" value="between"></el-option>
                            </el-select>
                            <el-input ref="search_3" class="search-item" size="small" style="width: 90px" v-model.trim="searchData.Amount1"></el-input>
                            <el-input class="search-item" size="small" style="width: 90px" v-model.trim="searchData.Amount2" v-if="searchData.Symbol == 'between'"></el-input>
                        </div>
                    </el-form-item>
                    <el-form-item label="状态">
                        <el-select ref="search_4" style="width: 100%" size="small" v-model="searchData.State">
                            <el-option v-for="item in stateList" :key="item.Value" :label="item.Text" :value="item.Value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="创建人">
                        <el-select ref="search_5" v-model="searchData.SId" size="small" style="width: 100%" filterable placeholder="请选择" clearable>
                            <el-option v-for="item in SIdList" :key="item.EmployeeId" :label="item.EmployeeName" :value="item.EmployeeId"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="备注">
                        <el-input ref="search_6" style="width: 100%" size="small" v-model="searchData.Remark" placeholder="请输入备注"></el-input>
                    </el-form-item>
                    <el-form-item label="创建日期">
                        <el-date-picker
                            size="small"
                            style="width: 100%"
                            v-model="datetime1"
                            type="daterange"
                            align="right"
                            unlink-panels
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            :picker-options="pickerOptions"
                            @change="onDate1TimeSelect"
                        ></el-date-picker>
                    </el-form-item>
                    <el-form-item label="提交日期" >
                        <el-date-picker size="small" style="width: 100%" v-model="datetime2" type="daterange" align="right"
                            unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                            :picker-options="pickerOptions" @change="onDate2TimeSelect"></el-date-picker>
                    </el-form-item>
                </el-form>
                <div class="dialog-footer">
                    <el-button class="btn-primary" size="small" @click="handleSearch">查询（Enter）</el-button>
                    <el-button size="small" icon="el-icon-refresh" @click="resetSearch">重置</el-button>
                    <el-button size="small" @click="closeSearchDialog">关闭（Esc）</el-button>
                </div>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" title="调拨单的操作记录" :visible.sync="OrderLifesVisible" width="1000px">
            <div class="dialog-content" v-if="OrderLifesVisible">
                <ordersLifes :OrderId="toId" :OrderType="8" @closeDialog="closeOrderLifesDialog"></ordersLifes>
            </div>
        </el-dialog>      
        <el-dialog :close-on-click-modal="false" title="查看调出标签" :visible.sync="showOutLabelsDialog" width="1200px" append-to-body>
            <div class="dialog-content" v-if="showOutLabelsDialog">
                <checkTranOutLabels @closeDialog="closeLabelsDialog" :OrderId="toId"></checkTranOutLabels>
            </div>
        </el-dialog>   
        <el-dialog :close-on-click-modal="false" title="查看调入标签" :visible.sync="showInLabelsDialog" width="1200px" append-to-body>
            <div class="dialog-content" v-if="showInLabelsDialog">
                <checkTranInLabels @closeDialog="closeLabelsDialog" :OrderId="toId"></checkTranInLabels>
            </div>
        </el-dialog>   
        <el-dialog :close-on-click-modal="false" title="查看外箱条码" :visible.sync="showBoxesDialog" width="1200px" append-to-body>
            <div class="dialog-content" v-if="showBoxesDialog">
                <checkTranBoxes @closeDialog="closeLabelsDialog" :OrderId="toId"></checkTranBoxes>
            </div>
        </el-dialog>  
        <el-dialog :close-on-click-modal="false" title="自定义搜索条件展示设置" @close="closeDialog" :visible.sync="searchSetVisible" append-to-body width="600px">
            <div class="dialog-content" v-if="searchSetVisible">
                <searchSets :tableCode="tableCode" @closeDialog="closeDialog"></searchSets>
            </div>
        </el-dialog>       
    </div>
</template>
<script>
import Vue from 'vue';
import elTableColumn from '@/components/common/chjtablecolumn';
import searchSets from '@/components/common/searchSets.vue';
import breadcrumb from '@/components/common/breadcrumb';
import warehouseOut from '@/components/business/goods/transWarehouseOut';
import warehouseIn from '@/components/business/goods/transWarehouseIn';
import checkTranInLabels from '@/components/business/goods/checkTranInLabels.vue';
import checkTranOutLabels from '@/components/business/goods/checkTranOutLabels.vue';
import checkTranBoxes from '@/components/business/goods/checkTranBoxes.vue';
import mixin from '@/mixins/mixin';
import pageLimitMixin from '@/mixins/pageLimitMixin';
import ordersLifes from '@/components/common/ordersLifes';
export default {
    mixins: [mixin, pageLimitMixin],
    name: '',
    components: {
        breadcrumb,
        elTableColumn,
        warehouseOut,
        warehouseIn,
        ordersLifes,
        searchSets,
        checkTranOutLabels,
        checkTranInLabels,
        checkTranBoxes
    },
    data() {
        return {
            summaryStr: '',
            datetime1: [],
            datetime2: [],
            toId: '',
            inVisible: false,
            outVisible: false,
            dialogVisible: false,
            showInLabelsDialog: false,
            showOutLabelsDialog: false,
            showBoxesDialog:false,
            searchSetVisible:false,
            tableCode:"TransWarehouse",
            ExportDetailsId:'',
            multipleSelection: null,
            dataReadonly: false,
            idList: [],
            WarehouseIdEdit: '',
            loading: false,
            warehouseList: [],
            positionList: [],
            searchData: {
                OrderCode: '',
                InWarehouseId: '',
                OutWarehouseId: '',
                State: '',
                Symbol: '',
                Amount1: 0,
                Amount2: 0,
                StartDate: '',
                EndDate: '',
                CStartDate: '',
                CEndDate: '',
                SId: '',
                Remark:'',
                Page: 1,
                limit: 15
            },
            tableData: [],
            tableDataLength: 0,
            permission: {},
            permissionTr: {},
            dialogSearchVisible: false,
            SIdList: [],
            stateList: [
                { Text: '全部', Value: '' },
                { Text: '未提交', Value: '0' },
                { Text: '已提交', Value: '1' },
                { Text: '已出仓', Value: '3' },
                { Text: '已完成', Value: '4' },
                { Text: '已撤销', Value: '5' }
            ],
            pickerOptions: {
                shortcuts: [
                    {
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近半年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
                            picker.$emit('pick', [start, end]);
                        }
                    }
                ]
            },
            isStartSearch: false,
            searchIndex: 0,
            OrderLifesVisible: false,
            isUseBox: false //是否使用箱子
        };
    },
    watch: {
        isStartSearch(newVal, oldVal) {
            if (newVal === true) {
                this.$nextTick(() => {
                    if (this.$refs.search_0) {
                        this.$refs.search_0.focus();
                        this.searchIndex = 0;
                    }
                });
            }
        }
    },
    activated() {
        document.addEventListener('keydown', this.handleKeyEvent);
        if (this.$store.state.needRefresh) {
            this.$store.commit('updateNeedRefresh', false);
            this.getTableData();
        }
        this.$nextTick(() => {
            this.$refs.multipleTable.doLayout();
        });
    },
    beforeRouteLeave(to, from, next) {
        document.removeEventListener('keydown', this.handleKeyEvent);
        if (this.dialogSearchVisible) this.dialogSearchVisible = false;
        next();
    },
    created() {
        if (this.tableCode) this.getSetsData();
        document.addEventListener('keydown', this.handleKeyEvent);
    },
    mounted() {
        this.permission = this.$util.getPermission('transWarehouse');
        // this.permissionTr = this.$util.getPermission('TransferringOrder');//这是/salesManage/transferringOrder销售单下调拨单的权限，屏蔽 edit by qdl 2023/10/6
        this.getConfigByCodes();
        // this.getTableData();
        let that = this;
        Vue.component('printTranContent', function (resolve) {
            that.$util.getPrintComponents(3).then(data => {
                if (data) {
                    require(['@/components/printModels/' + data], resolve);
                } else {
                    require(['@/components/printModels/printTransOrder'], resolve);
                }
            });
        });
    },
    methods: {
        getConfigByCodes() {
            let codes = ['ckxz'];
            this.$util.getSysConfigs(codes).then(data => {
                if (data) {
                    for (let i = 0; i < data.length; i++) {
                        let code = data[i].Code;
                        let result = data[i].Result;
                        let rValue = data[i].RValue;
                        switch (code) {
                            case 'ckxz':
                                this.isUseBox = result;
                                break;
                        }
                    }
                }
                this.getTableData();
            });
        },     
        getSetsData() {
            this.columnShowSets = [];
            this.$util.getTBSetsForShow(this.tableCode).then(data => {
                data.forEach(item => {
                    let colums = {
                        IsShow: item.IsShow,
                        Width: item.Width,
                        ColumnName: item.ColumnName,
                        ColumnCode: item.ColumnCode,
                        SortNum: item.SortNum,
                        IsSort: item.IsSort
                    };

                    this.columnShowSets.push(colums);
                });
            });
        },   
        handleKeyEvent(e) {
            let that = this;
            let key = window.event.keyCode;
            if(that.OrderLifesVisible)return;
            //F1
            if (key === 112) {
                e.preventDefault();
                if(that.permission.addTrans_v2)
                    that.gotoTransWarehouseEdit_v2(3);
                else
                    that.gotoTransWarehouseEdit_v2(3);
            }
            //F2
            if (key === 113) {
                e.preventDefault();
                that.showSearchDialog();
            }
            //F3
            if (key === 114) {
                e.preventDefault();
                that.print();
            }
            //F4
            if (key === 115) {
                e.preventDefault();
                that.gotoTransShelf();
            }
            //F5
            if (key === 116) {
                e.preventDefault();
                that.scanTransOut();
            }
            //F6
            if (key === 117) {
                e.preventDefault();
                that.scanTransIn();
            }
            //F7
            if (key === 118) {
                e.preventDefault();
                that.importTramsferOrder();
            }
            //F8
            if (key === 119) {
                e.preventDefault();
                that.dbHistories();
            }
            //F9
            if (key === 120) {
                e.preventDefault();
                that.dbPlan();
            }
            if (key === 13) {
                e.preventDefault();
                if (
                    (!that.$refs.search_1 || !that.$refs.search_1.visible) &&
                    (!that.$refs.search_2 || !that.$refs.search_2.visible) &&
                    (!that.$refs.search_4 || !that.$refs.search_4.visible) &&
                    that.dialogSearchVisible
                ) {
                    that.handleSearch();
                }
                else{
                    that.resetSearch();
                    that.getTableData();
                }
                that.isStartSearch = false;
            }
            if (key === 27) {
                e.preventDefault();
                if (that.dialogSearchVisible) {
                    that.dialogSearchVisible = false;
                }
            }
            //右键
            if (key === 39) {
                e.preventDefault();
                if (!this.dialogSearchVisible) {
                    let page = that.searchData.Page;
                    let limit = that.searchData.limit;
                    let totalPages = Math.ceil(that.tableDataLength / limit);
                    if (page < totalPages) {
                        that.searchData.Page += 1;
                        that.getTableData();
                    }
                }
                return;
            }
            //左键
            if (key === 37) {
                e.preventDefault();
                if (!that.dialogSearchVisible) {
                    if (that.searchData.Page !== 1) {
                        that.searchData.Page -= 1;
                        that.getTableData();
                    }
                }
                return;
            }
        },
        // 提交
        submit(row) {
            let that = this;
            this.$util.elConfirm({
                content: '确定要提交该调拨单吗？',
                noMsg: true,
                confirm() {
                    that.$util
                        .axiosPost({
                            url: `/api/EntpTransferOrder/NewSubmitEntpTransOrder?toId=${row.TOId}`,
                        })
                        .then(res => {
                            if(res.errmsg.includes("调出数量不得大于库存数量")){
                                that.$util.warningMsg(res.errmsg);
                            }else{
                                that.$util.successMsg('提交调拨单成功');
                            }
                            that.getTableData();
                        })
                        .catch(() => {});
                }
            });
        },
        // 删除
        del(row) {
            let that = this;
            this.$util.elConfirm({
                content: '确定要删除该调仓吗？',
                noMsg: true,
                confirm() {
                    that.$util
                        .axiosPost({
                            url: `/api/EntpTransferOrder/NewDelEntpTransOrder?toId=${row.TOId}`,
                        })
                        .then(() => {
                            that.$util.successMsg('删除成功');
                            that.getTableData();
                        })
                        .catch(() => {});
                }
            });
        },
        // 出仓
        warehouseOut(id) {
            if (id) {
                this.toId = id;
                this.outVisible = true;
            }
        },
        closeOutDialog(edit) {
            this.outVisible = false;
            this.toId = '';
            if (edit) this.getTableData();
        },
        // 入仓
        warehouseIn(id) {
            if (id) {
                this.toId = id;
                this.inVisible = true;
            }
        },
        ExportDetails(row){
            this.$util
                .exportFile({
                    url: `/api/EntpTransferOrder/ExportEnterpriseTransferOrder`,
                    data: {Id : row.TOId}
                });
        },
        closeInDialog(edit) {
            this.inVisible = false;
            this.toId = '';
            if (edit) this.getTableData();
        },
        cancel(row) {
            let that = this;
            this.$util.elConfirm({
                content: '确定要撤销该调仓吗？',
                noMsg: true,
                confirm() {
                    that.$util
                        .axiosPost({
                            url: `/api/EntpTransferOrder/NewCancelEntpTransOrder?toId=${row.TOId}`,
                        })
                        .then(() => {
                            that.$util.successMsg('撤销成功');
                            that.getTableData();
                        })
                        .catch(() => {});
                }
            });
        },
        //跳转导入开单界面
        importTramsferOrder(){
            this.$router.push(`/inventoryManage/transWarehouse/importTransWarehouseExcel`);
        },
        //跳转导入开单界面
        dbPlan(){
            this.$router.push(`/inventoryManage/transWarehouse/PlanDetail?Type=1`);
        },
        dbHistories(){
            this.$router.push(`/inventoryManage/transWarehouse/Historiesor?Type=2`);
        },
        gotoTransWarehouseEdit(type, row) {
            let TOId = row ? row.TOId : '';
            let from = this.$route.meta.from;
            if (from == 'inventory') {
                this.$router.push(`/inventoryManage/transWarehouse/edit?type=${type}&TOId=${TOId}`);
            } else {
                this.$router.push(`/salesManage/transWarehouse/edit?type=${type}&TOId=${TOId}`);
            }
        },
        gotoTransWarehouseEdit_v2(type, row){
            let TOId = row ? row.TOId : '';
            let from = this.$route.meta.from;
            if (from == 'inventory') {
                this.$router.push(`/inventoryManage/transWarehouse/edit_v2?type=${type}&TOId=${TOId}`);
            } else {
                this.$router.push(`/salesManage/transWarehouse/edit_v2?type=${type}&TOId=${TOId}`);
            }
        },
        gotoTransShelf() {
            this.$router.push(`/inventoryManage/transSpaces`);
        },
        getTableData() {
            this.$util
                .axiosGet({
                    url: '/api/EntpTransferOrder/NewGetEntpTransOrderList',
                    data: this.searchData
                })
                .then(res => {
                    let data = res.data;
                    if (!data) data = [];

                    this.tableData = data.DataList;
                    this.summaryStr = data.SummaryStr;
                    this.tableDataLength = res.count;
                })
                .catch(() => {});
        },
        // 获取仓库列表
        getWarehouse() {
            if (this.warehouseList.length == 0) {
                this.$util.getWarehouse(1).then(data => {
                    this.warehouseList = data;
                });
            }
        },
        resetSearch() {
            this.searchData = {
                OrderCode: '',
                InWarehouseId: '',
                OutWarehouseId: '',
                State: '',
                Symbol: '',
                Amount1: 0,
                Amount2: 0,
                StartDate: '',
                EndDate: '',
                CStartDate: '',
                CEndDate: '',
                SId: '',
                Remark:'',
                Page: 1,
                limit: this.commonPageSize
            };
            this.datetime1 = [];
            this.datetime2 = [];
        },
        handleSearch() {
            this.searchData.Page = 1;
            this.getTableData();
        },
        handleSizeChange(val) {
            this.searchData.Page = 1;
            this.searchData.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.searchData.Page = val;
            this.getTableData();
        },
        handleDBClick(event) {
            if (event) {
                if(this.permission.addTrans_v2){
                this.gotoTransWarehouseEdit_v2(1, event);
                }else{
                    this.gotoTransWarehouseEdit(1, event);
                }
            }
        },
        closeDialog() {
            this.dialogVisible = false;
            this.getTableData();
        },
        // 打印
        print() {
            if (this.idList.length == 0) {
                this.$util.warningMsg('请选择一张调拨单打印');
                return;
            } else if (this.idList.length > 1) {
                this.$util.warningMsg('只能选择一张调拨单打印');
                return;
            }
            if (this.multipleSelection[0].StateName == '已撤消') {
                this.$util.warningMsg('不能打印已撤消的调拨单');
                return;
            }
            if (this.multipleSelection[0].IsCanSubmit) {
                this.$util.warningMsg('不能打印未提交的调拨单');
                return;
            }
            if (this.multipleSelection[0].OutWarehouseType == 1) {
                this.$util.warningMsg('不能打印调出仓库为前置仓的调拨单');
                return;
            }
            this.dialogVisible = true;
        },
        handleSelectionChange(val) {
            let idList = [];
            this.multipleSelection = val;
            for (let i = 0; i < val.length; i++) {
                idList.push(val[i].TOId);
            }
            this.idList = idList;
        },
        scanTransOut(tOId) {
            if(!this.isUseBox){
                 if (tOId) this.$router.push(`/inventoryManage/transWarehouse/transOrderScanOut?stype=1&TOId=${tOId}`);
            else this.$router.push(`/inventoryManage/transWarehouse/transOrderScanOut?stype=0`);
            }else{
                  if (tOId) this.$router.push(`/inventoryManage/transWarehouse/transOrderScanOut_v2?stype=1&TOId=${tOId}`);
            else this.$router.push(`/inventoryManage/transWarehouse/transOrderScanOut_v2?stype=0`);
            }
           
        },
        scanTransIn(tOId) {
            if(!this.isUseBox){
                if (tOId) this.$router.push(`/inventoryManage/transWarehouse/transOrderScanIn?stype=1&TOId=${tOId}`);
                else this.$router.push(`/inventoryManage/transWarehouse/transOrderScanIn?stype=0`);
            }else{
                  if (tOId) this.$router.push(`/inventoryManage/transWarehouse/transOrderScanIn_v2?stype=1&TOId=${tOId}`);
            else this.$router.push(`/inventoryManage/transWarehouse/transOrderScanIn_v2?stype=0`);
            }

        },
        showSearchDialog() {
            if (this.SIdList.length <= 1) this.getSIdList();
            this.dialogSearchVisible = true;
            this.isStartSearch = true;
        },
        closeSearchDialog() {
            this.dialogSearchVisible = false;
        },
        getSIdList() {
            this.$util.getSIdList().then(data => {
                this.SIdList = data;
            });
        },
        onDate1TimeSelect(val) {
            if (val != null) {
                this.searchData.StartDate = val[0];
                this.searchData.EndDate = val[1];
            } else {
                this.searchData.StartDate = '';
                this.searchData.EndDate = '';
            }
        },
        onDate2TimeSelect(val) {
            if (val != null) {
                this.searchData.CStartDate = val[0];
                this.searchData.CEndDate = val[1];
            } else {
                this.searchData.CStartDate = '';
                this.searchData.CEndDate = '';
            }
        },
        opRecords(item) {
            let id = item ? item.TOId : '';
            if (id) {
                this.toId = id;
                this.OrderLifesVisible = true;
            } else {
                this.$util.warningMsg('订单数据异常，请刷新后重新操作');
            }
        },
        closeOrderLifesDialog() {
            this.OrderLifesVisible = false;
        }, 
         //关闭订单弹出层
         closeLabelsDialog() {
            this.toId = '';
            if(this.showOutLabelsDialog) this.showOutLabelsDialog = false;
            if(this.showInLabelsDialog) this.showInLabelsDialog = false;
            if(this.showBoxesDialog) this.showBoxesDialog = false;
        },
        showOutLabelDetails(row) {
            if (row) {
                this.toId = row.TOId;
                this.showOutLabelsDialog = true;
            } else {
                this.$util.warningMsg('请选择单据进行查看');
                return;
            }
        },    
        showInLabelDetails(row) {
            if (row) {
                this.toId = row.TOId;
                this.showInLabelsDialog = true;
            } else {
                this.$util.warningMsg('请选择单据进行查看');
                return;
            }
        },     
        showBoxDetails(row) {
            if (row) {
                this.toId = row.TOId;
                this.showBoxesDialog = true;
            } else {
                this.$util.warningMsg('请选择单据进行查看');
                return;
            }
        },              
    }
};
</script>
<style lang="less" scoped>
#search-trans-dialog {
    position: absolute;
    top: 0;
    left: 50%;
    right: auto;
    bottom: auto;
    width: 10px;
    height: 10px;
    overflow: visible;
    .el-dialog {
        box-shadow: 0 0 9px 3px #999;
    }
    .search-item-dialog {
        width: 340px;
        height: auto;
        .dialog-footer {
            text-align: right;
        }
        .el-form-item {
            margin-bottom: 0;
        }
    }
    .el-dialog__body {
        height: calc(100% - 54px);
        overflow: auto;
    }
}
</style>
<style lang="less">
.trans-order {
    .el-table__row {
        td:nth-child(2) {
            .cell {
                overflow: visible;
            }
        }
    }
}
</style>
